import { configureStore } from '@reduxjs/toolkit'
import cropReducer from './slices/cropslice';


const reducer = {
    //   auth: authReducer
    crop:cropReducer
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
})

export default store;